import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";

import { currencyFormatter } from "../../utils/Utils";

export default function InvoiceDetails({ invoice }) {
  const details = {
    // "No.": invoice.no,
    "Invoice Date": invoice.postingDate,
    "Due Date": invoice.dueDate,
    "Payment Terms": invoice.paymentTermsCode,
    Total: currencyFormatter(invoice.currencyCode, invoice.amount || 0),
    "Total inc. VAT": currencyFormatter(
      invoice.currencyCode,
      invoice.amountInclVat || 0,
    ),
    Paid: invoice.paid,
  };

  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>
        Details
      </Typography>
      <Grid
        container
        spacing={{ xs: 2, md: 2 }}
        columns={{ xs: 2, sm: 2, md: 3 }}
      >
        {Object.entries(details).map(([key, value], i) => (
          <Grid
            key={key}
            size={{
              xs: 1,
              sm: 1,
              md: 1,
            }}
          >
            <TextField
              size="small"
              fullWidth
              id={`${key}-input`}
              label={key}
              value={value || ""}
              slotProps={{
                input: {
                  readOnly: true,
                },
              }}
            />
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
}
